/*
 * @Description: 登陆
 * @Author: WangYuhan
 * @Date: 2022-12-09 17:54:05
 * @LastEditTime: 2023-11-10 11:02:43
 * @LastEditors: WangYuhan
 */

// import store from '@/store/index'
import { get, post, prefix } from './base';

// 登录指定集团
export function loginGroup(params) {
  return get(`${prefix}login/group`, params);
}
// 退出
export function logout(params) {
  return get(`${prefix}employeeUser/noAuth/logout`, params);
}

// 密码重置密码
export function updatePassword(params) {
  return post(`${prefix}update/password`, params);
}

// 根据token获取用户信息
export function getUserInfo() {
  return get(`${prefix}employeeUser/refresh`);
}

// 根据集团id获取token
export function getOneStopToken(params) {
  return get(`${prefix}admin/adminGroup/getOneStopToken`, params);
}

// 发送验证码
export function requestSMSCode(params) {
  return post(`${prefix}requestSMSCode`, params);
}

// 验证码登录
export function verifySMSCode(params) {
  return post(`${prefix}login/SMSCodeV2`, params);
}

// 密码登录
export function verifyPassword(params) {
  return post(`${prefix}login/passwordV2`, params);
}

// 修改密码
export function restAndLogout(params) {
  return post(`${prefix}rest/restAndLogout`, params);
}

export function saveAssistant(params) {
  return get(`${prefix}open/saveAssistant`, params);
}

// 获取验证码（商户端）
export function querySmsCode(params) {
  return get(`${prefix}querySmsCode`, params);
}

//注册商户
export function register(params) {
  return post(`${prefix}register`, params);
}

// 校验注册验证码
export function checkSMSCode(params) {
  return post(`${prefix}register/SMSCode`, params);
}

// 密码登录V2
export function loginByPassword(params) {
  return post(`${prefix}employeeUser/noAuth/loginByPassword`, params);
}

// 验证码登录V2
export function loginBySmsCode(params) {
  return post(`${prefix}employeeUser/noAuth/loginBySmsCode`, params);
}

// 发送短信验证码（登录、注册、重置密码）
export function requestSmsCode(params) {
  return post(`${prefix}employeeUser/noAuth/requestSmsCode`, params);
}

export function binding(data) {
  return post(`${prefix}binding`, data);
}

// 校验注册验证码
export function sendContactMsg(params) {
  return get(`${prefix}open/sendContactMsg`, params);
}

// 校验该用户是否有集团和企业
export function checkUserGroupCorporationInfo(params) {
  return post(`${prefix}outer/unified/checkUserGroupCorporationInfo`, params);
}

// 入住牛运宝
export function groupRegister(params) {
  return post(`${prefix}outer/unified/groupRegister`, params);
}

// 获取企业信息
export function middleCorporationInfoByToken(params) {
  return post(`${prefix}outer/unified/middleCorporationInfoByToken`, params);
}
